import React from 'react';
import { PRODUCT_NAME, SUPPORT_EMAIL } from '../data/content';
export function Footer() {
  return <footer className="border-t-4 border-coral bg-ink pb-16" data-id="element-71" data-mp="3gfivmltl4hfp">
      <div className="mx-auto max-w-xl px-3 py-4 text-center sm:px-5" data-id="element-72" data-mp="3gh3s4gzgmag7">
        <p className="text-xs leading-snug text-tint" data-id="element-73" data-mp="32pfc42m3b1ty">
          © 2026 — Todos los Derechos Reservados.
        </p>
        <p className="mt-1 text-[11px] leading-snug text-white/70" data-id="element-74" data-mp="36nd75m2jki59">
          {PRODUCT_NAME} es un producto educativo complementario. No sustituye
          formación académica oficial, prácticas clínicas supervisadas,
          protocolos institucionales, indicaciones médicas, habilitaciones
          profesionales ni el criterio del personal sanitario capacitado. Los
          ejercicios clínicos y farmacológicos son simulados y deben utilizarse
          únicamente con fines de estudio.
        </p>
        <p className="mt-1.5 text-xs text-white" data-id="element-75" data-mp="2a1jjpa3jzw2z">
          Soporte:{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`} className="font-semibold text-teal transition-colors duration-150 ease-out hover:text-white" data-id="element-76" data-mp="2ezl3jx8szzfi">
            {SUPPORT_EMAIL}
          </a>
        </p>
        <nav aria-label="Enlaces legales" className="mt-1.5 flex flex-wrap items-center justify-center gap-x-1.5 gap-y-1 text-xs text-white" data-id="element-77" data-mp="3gctmyhqo8do6">
          <a href="#terminos" className="transition-colors duration-150 ease-out hover:text-coral" data-id="element-78" data-mp="3q7bvc0718xeb">
            Términos y Condiciones
          </a>
          <span className="text-coral/70" aria-hidden="true" data-id="element-79" data-mp="335tdib8plh0">•</span>
          <a href="#privacidad" className="transition-colors duration-150 ease-out hover:text-coral" data-id="element-80" data-mp="htd0j1vsri2e">
            Política de Privacidad
          </a>
          <span className="text-coral/70" aria-hidden="true" data-id="element-81" data-mp="qt8grl47m39a">•</span>
          <a href={`mailto:${SUPPORT_EMAIL}`} className="transition-colors duration-150 ease-out hover:text-coral" data-id="element-82" data-mp="qrfba95c1p2v">
            Contacto
          </a>
        </nav>
      </div>
    </footer>;
}